import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  DxButtonComponent,
  DxNumberBoxComponent,
  DxSelectBoxComponent,
  DxValidationGroupComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import { DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';
import notify from 'devextreme/ui/notify';
import { PrintBarCodeModel } from 'src/app/models/print-barcode-model';

@Component({
  selector: 'app-popup-barcode',
  templateUrl: './popup-barcode.component.html',
  styleUrls: ['./popup-barcode.component.scss'],
  imports: [
    DxButtonComponent,
    DxSelectBoxComponent,
    DxNumberBoxComponent,
    DxValidationGroupComponent,
    DxiValidationRuleComponent,
    DxValidatorComponent,
  ],
})
export class PopupBarCodeComponent {
  @Output() popupBarcodeEventEmitter = new EventEmitter<PrintBarCodeModel>();
    @ViewChild('validationGroup', { static: false })
  validationGroup!: DxValidationGroupComponent;
  dimensione: string;
  numeroCopie: number = 1;
  infoBarCode: PrintBarCodeModel;

  listDimensioni = [
    {
      id: 'Grande',
      descrizione: 'Grande (6 x 3 cm)',
    },
    {
      id: 'Piccolo',
      descrizione: 'Piccolo (3 x 1 cm)',
    },
  ];

  onStampaClick() {
    const result = this.validationGroup.instance.validate();
    if (!result.isValid) {
      notify("Inserire tutti i campi richiesti", "warning");
      return;
    }
    this.infoBarCode = new PrintBarCodeModel();
    this.infoBarCode.numeroCopie = this.numeroCopie;
    this.infoBarCode.grande = this.dimensione == 'Grande';
    this.popupBarcodeEventEmitter.emit(this.infoBarCode);
  }
}
